import useSWRMutation from 'swr/mutation';
import { useAuth0 } from '@auth0/auth0-react';
import http from '@/Utils/HTTP/NewHttpUtils';
import { GeocodeResponse, PlaceType } from './DTO/GeocodeResponse';

interface GeocodeRequest {
    location: string;
}

const DefaultGeocodeResponse: GeocodeResponse = {
    placeId: '',
    placeType: PlaceType.Country,
    title: '',
    position: [0, 0],
    locality: null,
    subRegion: null,
    region: null,
    country: null,
    localityName: null,
    regionName: null,
};

const useGeocode = () => {
    const { getAccessTokenSilently } = useAuth0();

    return useSWRMutation('ai-search/geocode', async (path: string, { arg }: { arg: string }) => {
        const payload: GeocodeRequest = {
            location: arg,
        };

        const response = await http.post<GeocodeResponse>({
            path,
            accessToken: await getAccessTokenSilently(),
            body: payload,
        });

        return response || DefaultGeocodeResponse;
    });
};

export default useGeocode;
